import aaina from "../../assets/trusted-brand/aaina.png";
import accenture from "../../assets/trusted-brand/accenture.png";
import aicPinnacle from "../../assets/trusted-brand/aicPinnacle.png";
// import apollo from "../../assets/trusted-brand/apollo.png";
import cars24 from "../../assets/trusted-brand/cars24.png";
import certifyMe from "../../assets/trusted-brand/certifyMe.png";
import collegedunia from "../../assets/trusted-brand/collegedunia.png";
import deshpandeFoundation from "../../assets/trusted-brand/deshpandeFoundation.png";
import edvora from "../../assets/trusted-brand/edvora.jpg";
import frontrow from "../../assets/trusted-brand/frontrow.png";
import genpact from "../../assets/trusted-brand/genpact.png";
import groww from "../../assets/trusted-brand/groww.png";
import inc42 from "../../assets/trusted-brand/inc42.png";
import innocity from "../../assets/trusted-brand/innocity.png";
import jaroEducation from "../../assets/trusted-brand/jaroEducation.png";

// Import images for the second trusted brands
import justdial from "../../assets/trusted-brand/justDial.png";
import kiitTBI from "../../assets/trusted-brand/kiittbi.png";
import kredily from "../../assets/trusted-brand/kredily.png";
import kuhoo from "../../assets/trusted-brand/kuhoo.png";
import leverageEdu from "../../assets/trusted-brand/leverageEdu.png";
import mindianmart from "../../assets/trusted-brand/indiaMart.png";
import nobroker from "../../assets/trusted-brand/nobroker.png";
import oyo from "../../assets/trusted-brand/oyo.png";
import paytm from "../../assets/trusted-brand/paytm.png";
import simplilearn from "../../assets/trusted-brand/simpliLearn.png";
import startupOasis from "../../assets/trusted-brand/startupOasis.png";
import startupIndia from "../../assets/trusted-brand/startupindia.png";
import tata from "../../assets/trusted-brand/tata1Mg.png";
import timesInternet from "../../assets/trusted-brand/timesInternet.png";
import travClan from "../../assets/trusted-brand/travClan.jpg";
import upGrad from "../../assets/trusted-brand/upgrad.png";

export const firstTrustedBrands = [
  { name: "Aaina", src: aaina },
  { name: "Accenture", src: accenture },
  { name: "AIC PINNACLE", src: aicPinnacle },
  // { name: "Apollo", src: apollo },
  { name: "CARS 24", src: cars24 },
  { name: "Certify Me", src: certifyMe },
  { name: "Collegedunia", src: collegedunia },
  { name: "Deshpande Foundation", src: deshpandeFoundation },
  { name: "Edvora", src: edvora },
  { name: "FRONTROW", src: frontrow },
  { name: "Genpact", src: genpact },
  { name: "Groww", src: groww },
  { name: "Inc 42", src: inc42 },
  { name: "INNOCITY", src: innocity },
  { name: "Jaro Education", src: jaroEducation },
];

export const secondTrustedBrands = [
  { name: "Justdial", src: justdial },
  { name: "KIIT-TBI", src: kiitTBI },
  { name: "KREDILY", src: kredily },
  { name: "Kuhoo", src: kuhoo },
  { name: "Leverage Edu", src: leverageEdu },
  { name: "Mindianmart", src: mindianmart },
  { name: "NOBROKER", src: nobroker },
  { name: "OYO", src: oyo },
  { name: "Paytm", src: paytm },
  { name: "Simplilearn", src: simplilearn },
  { name: "Startup Oasis", src: startupOasis },
  { name: "Startup India", src: startupIndia },
  { name: "Tata", src: tata },
  { name: "Times Internet", src: timesInternet },
  { name: "TravClan", src: travClan },
  { name: "upGrad", src: upGrad },
];
